import React from 'react';
import { HeartIcon, ShareIcon, PrinterIcon, DownloadIcon } from 'lucide-react';
export function ActionButtons() {
  return <div className="flex flex-wrap gap-3" data-id="element-3">
      <button className="flex items-center px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 bg-white hover:bg-gray-50" data-id="element-4">
        <HeartIcon size={16} className="mr-2" data-id="element-5" />
        <span data-id="element-6">Save</span>
      </button>
      <button className="flex items-center px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 bg-white hover:bg-gray-50" data-id="element-7">
        <ShareIcon size={16} className="mr-2" data-id="element-8" />
        <span data-id="element-9">Share</span>
      </button>
      <button className="flex items-center px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 bg-white hover:bg-gray-50" data-id="element-10">
        <PrinterIcon size={16} className="mr-2" data-id="element-11" />
        <span data-id="element-12">Print</span>
      </button>
      <button className="flex items-center px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 bg-white hover:bg-gray-50" data-id="element-13">
        <DownloadIcon size={16} className="mr-2" data-id="element-14" />
        <span data-id="element-15">Download PDF</span>
      </button>
    </div>;
}